export class Org {
    constructor(
        public orgGuid: string = '',
        public orgId: number = NaN,
        public orgName: string = '',
        public orgType: string = '',
        public parentOrg: number = NaN,
        public children: Org[] = <Org[]>[]
    ) { }
}

export class App {
    constructor(public appId: string = '', public title: string = '', public orgGuid: string = '') { }
}

export class PreferenceItem {
    constructor(public selectedFriendlyName: string = '', public selectedId: string = '') { }
}

export class Preferences {
    currentOrg: PreferenceItem[];
    currentApp: PreferenceItem[];
    completedInteractiveTours: PreferenceItem[];

    constructor(preferences: Preferences = {} as Preferences) {
        Object.assign(this, preferences);
    }

    getPreferencesItem(key: string): PreferenceItem {
        return (this[key] && (this[key].length > 0))
            ? this[key][0]
            : null;
    }

    getPreferencesItemValue(key: string): string {
        const preferencesItem = this.getPreferencesItem(key);
        return preferencesItem ? preferencesItem.selectedId : '';
    }
}
